// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoSection_container__25ruW","aboutSection":"VideoSection_aboutSection__3m_Il","videoSection":"VideoSection_videoSection__W2sjN"};